(function() {
    "use strict";

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(text) {
            text = String(text);
            return this.length >= text.length && this.substring(0, text.length) == text;
        };
    }
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/String.startsWith.js